import { useEffect } from 'react';

type Args = {
  isOpen: boolean;
};

export const useDisableModalBackScroll = ({ isOpen }: Args): void => {
  useEffect(() => {
    if (!isOpen) return;

    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
};
